import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";

import { EnabledPipe } from "../../../../../helpers/enabledpipe/enabledpipe";
import { IpSubscriptionDetails } from "../../../../../pages/subscription-detail/types";
import { AuthService } from "../../../../../services/authservice";
import { SelfserviceToggle } from "../../../../selfservice/selfservice-toggle/selfservice-toggle";
import { PortSummary } from "../../../port-summary/port-summary";

type IpSap = IpSubscriptionDetails["saps"][number];

@Component({
  selector: "ip-sap-panel",
  templateUrl: "ip-sap-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [EnabledPipe, SelfserviceToggle, PortSummary, TranslatePipe],
})
export class IpSapPanel {
  protected auth = inject(AuthService);

  sap = input.required<IpSap>();
  ipRoutingType = input.required<string>();
  isInfrastructureDelegate = input.required<boolean>();

  selfServiceOpen = output<string>();

  protected port = computed(() => this.sap().port ?? null);
  protected subscriptionInstanceId = computed(() => this.sap().subscriptionInstanceId);
  protected vlanranges = computed(() => (this.sap().vlanrange ? [this.sap().vlanrange] : []));

  protected isBgp = computed(() => this.ipRoutingType() === "BGP");

  protected bgpSessionPriority = computed(() => this.sap().bgpSessionPriority);
  protected bgpExportPolicy = computed(() => this.sap().bgpExportPolicy);
  protected bgpPassword = computed(() => this.sap().bgpPassword);
  protected gracefulRestart = computed(() => this.sap().gracefulRestart);
  protected bfd = computed(() => this.sap().bfd);
  protected ipv4SurfIpAddress = computed(() => this.sap().ipv4PointToPointPrefix?.surfIpAddress);
  protected ipv4ClientIpAddress = computed(() => this.sap().ipv4PointToPointPrefix?.clientIpAddress);
  protected ipv4Mtu = computed(() => this.sap().ipv4Mtu);

  protected ipv6SurfIpAddress = computed(() => this.sap().ipv6PointToPointPrefix?.surfIpAddress);
  protected ipv6ClientIpAddress = computed(() => this.sap().ipv6PointToPointPrefix?.clientIpAddress);
  protected ipv6Mtu = computed(() => this.sap().ipv6Mtu);

  protected ipPrefixes = computed(() => this.sap().ipPrefixes);
  protected hasIpPrefixes = computed(() => !!this.ipPrefixes().length);

  protected hasConfigurationDetails = computed(
    () =>
      this.isBgp()
      || !!this.sap().ipv4PointToPointPrefix
      || !!this.sap().ipv6PointToPointPrefix
      || this.hasIpPrefixes(),
  );
}
